
import { isEmpty } from 'lodash';
import Decimal from 'decimal.js';
import AdsApi from '../../libs/ads-request/ads-api';
import { validateAccess } from '../../libs/helpers';
import EventBus from '../../events';
import _const from '../../const';

export default {
  name: 'PaymentOrder',
  inheritAttrs: false,
  props: {
    shadow: Boolean,
  },
  data: () => ({
    orderDetail: {},
    servicesPackages: [],
    ppsoPackages: [],
    parts: [],
    labours: [],
    otherCharges: [],
    client: {},
    total: 0,
    subtotal: 0,
    taxes: 0,
    expandPrefecture: true,
    expandVehicle: true,
    expandCustomer: true,
    expandDetail: true,
    isChecklistEnabled: false,
    isPaymentEnabled: false,
    showView: false,
    loaderError: false,
    loaderMessage: '',
    guaranteeAmounts: {
      subtotal: 0,
      discount: 0,
      taxes: 0,
      total: 0,
    },
    cancelledAmounts: {
      subtotal: 0,
      discount: 0,
      taxes: 0,
      total: 0,
    },
    isQuotation: false,
  }),
  computed: {
    mobile() {
      return this.$q.screen.lt.md;
    },
  },
  watch: {
    isChecklistEnabled(val) {
      if (val) this.expandDetail = false;
    },
  },
  mounted() {
    this.initialCharge();
  },
  methods: {
    isEmpty,
    async initialCharge() {
      try {
        EventBus.$on('validateViews', () => {
          this.changePaymentEnabled();
          this.changeChecklistEnabled();
        });
        this.changePaymentEnabled();
        if (this.isPaymentEnabled) this.loaderMessage = 'Cargando pre-factura ...';
        else this.loaderMessage = 'Cargando orden inicial ...';
        await this.getPreinvoice();
        this.changeChecklistEnabled();
        this.showView = true;
      } catch (error) {
        this.loaderError = true;
      }
    },
    changeChecklistEnabled() {
      this.isChecklistEnabled = validateAccess(_const.MODULE_ADDITIONAL_BUDGETS);
    },
    changePaymentEnabled() {
      this.isPaymentEnabled = validateAccess(_const.MODULE_PAYMENT);
    },
    getPreinvoice() {
      return AdsApi.getPreinvoice()
        .then((data) => {
          const index = 0;
          this.orderDetail = data.services[index];

          data.services.forEach((service) => { this.servicesRemap(service); });

          this.totals(data);
        })
        .catch((error) => {
          throw error;
        });
    },
    servicesRemap(service) {
      if (service.serviceType === 'Garantía' && service.status !== 'Cancelada') {
        this.guaranteeAmounts.subtotal = Decimal(this.guaranteeAmounts.subtotal).add(
          new Decimal(service.subtotal),
        );
        this.guaranteeAmounts.discount = Decimal(this.guaranteeAmounts.discount).add(
          new Decimal(service.discount),
        );
        this.guaranteeAmounts.taxes = Decimal(this.guaranteeAmounts.taxes)
          .add(new Decimal(service.taxesAmount));
        this.guaranteeAmounts.total = Decimal(this.guaranteeAmounts.total)
          .add(new Decimal(service.total));
      } else if (service.status === 'Cancelada' && service.serviceType !== 'Garantía') {
        this.cancelledAmounts.subtotal = Decimal(this.cancelledAmounts.subtotal).add(
          new Decimal(service.subtotal),
        );
        this.cancelledAmounts.discount = Decimal(this.cancelledAmounts.discount).add(
          new Decimal(service.discount),
        );
        this.cancelledAmounts.taxes = Decimal(this.cancelledAmounts.taxes)
          .add(new Decimal(service.taxesAmount));
        this.cancelledAmounts.total = Decimal(this.cancelledAmounts.total)
          .add(new Decimal(service.total));
      } else {
        if (service.servicePackages.length > 0) {
          this.servicesPackages = this.servicesPackages.concat(service.servicePackages);
        }
        if (service.ppsoPackages.length > 0) {
          this.ppsoPackages = this.ppsoPackages.concat(service.ppsoPackages);
        }
        if (service.labours.length > 0) {
          this.labours = this.labours.concat(service.labours);
        }
        if (service.otherCharges.length > 0) {
          this.otherCharges = this.otherCharges.concat(service.otherCharges);
        }
        if (service.parts.length > 0) this.parts = this.parts.concat(service.parts);

        this.guaranteeAmounts.subtotal = Decimal(this.guaranteeAmounts.subtotal).add(0);
        this.guaranteeAmounts.discount = Decimal(this.guaranteeAmounts.discount).add(0);
        this.guaranteeAmounts.taxes = Decimal(this.guaranteeAmounts.taxes).add(0);
        this.guaranteeAmounts.total = Decimal(this.guaranteeAmounts.total).add(0);
      }
    },
    totals(data) {
      this.total = Decimal(data.total).minus(Decimal(this.guaranteeAmounts.total))
        .minus(Decimal(this.cancelledAmounts.total))
        .toFixed(2);
      this.subtotal = Decimal(data.subtotal).minus(Decimal(this.guaranteeAmounts.subtotal))
        .minus(Decimal(this.cancelledAmounts.subtotal))
        .toFixed(2);
      this.taxes = Decimal(data.taxesAmount).minus(Decimal(this.guaranteeAmounts.taxes))
        .minus(Decimal(this.cancelledAmounts.taxes))
        .toFixed(2);
      this.isQuotation = this.total > 0;
    },
  },
};
